import * as React from "react";
import { Col, Row } from "reactstrap";

import {
  ComboBox,
  TextField,
  Dropdown,
  ChoiceGroup,
  MessageBar,
  MessageBarType,
  Spinner,
  SpinnerSize,
  IDropdownOption,
  IChoiceGroupOption,
  Stack,
  Callout,
  FocusTrapZone,
  Calendar,
  DirectionalHint,
  PrimaryButton
} from "@fluentui/react";

// import logo from "../../Assets/RohrgefuehrteMedienLogo.png";
import logo from "../assets/RohrgefuehrteMedienLogo.svg";

import { BetriebsweiseOPSConsts, constGenericDropdownPlaceholder, constVarianteKeyAbmeldung, constVarianteKeyAenderung, constVarianteKeyErstanforderung, constVarianteKeySonderfall, DateStrings } from "../../../../common/CommonConstants";
import { apiEndpointSubmit, constZyklusMaxWidthChar, FormFieldsRM, VariantenRM } from "./RohrgefuehrteMedienRequestConstants";

import * as commonCode from "../../../../common/components/request/RequestCommonCode";

import { IRohrgefuehrteMedienRequestProps } from "./IRohrgefuehrteMedienRequestProps";
import { IRohrgefuehrteMedienRequestState } from "./IRohrgefuehrteMedienRequestState";

import "bootstrap/dist/css/bootstrap.css";
import "../../../../common/components/request/fabric.css";                    // radio buttons horizontal layout
import { ICompany, IGenericOption } from "../../../../common/CommonTypes";
import { IMedium, RohrgefuehrteMedienErrors, RohrgefuehrteMedienRecord } from "./RohrgefuehrteMedienRequestTypes";
import { BaseDataFragment } from "../../../../common/components/request/BaseDataFragment";
import { dropdownStyles, stylesTextFieldSupressDisabledLookFN } from "../../../../common/CommonStyles";


class RohrgefuehrteMedienRequest extends React.Component<IRohrgefuehrteMedienRequestProps, IRohrgefuehrteMedienRequestState> {

  private buttonContainerRef = React.createRef<HTMLDivElement>();
  private VariantenOPS: IGenericOption[];
  
  constructor(props: any) {
    super(props);

    let medium: IMedium;

    if (this.props.currentRecord) {
      medium = this.props.medien.filter(c => c.Medium === this.props.currentRecord.Medium)[0];
    }

    this.VariantenOPS = VariantenRM.map(v => ({ key: v.Key, text: v.RadioButtonLabel }));

    this.state = {
      AntragstellerFirmaOPS: this.props.companies.map(c => ({key: c.Name, text: c.Name})),    // !SK! Changed to .Name from .Key
      companyAllowFreeform: true,
      // companyIsISG: req ? company?.IstISG : false,
      companyIsISG: this.props.currentRecord ? 
        this.props.companies.filter(c => c.Name === this.props.currentRecord.AntragstellerFirma)[0]?.IstISG : false,     // !SK! Changed to .Name from .Key
      showCalendar: false,
      showSpinner: false,
      // formReadOnly: req ? true : false,
      formReadOnly: this.props.currentRecord ? true : false,
      // formReadOnly: false,
      submitMessage: "",
      minDate: new Date,
      MediumOPS: this.props.medien.map(el => ({key: el.Medium, text: el.Medium})), 
      // MediumKurzzeichenOPS: req ? [{key: medium.MediumKurzzeichen, text: medium.MediumKurzzeichen}] : [],    
      MediumKurzzeichenOPS: this.props.currentRecord ? [{key: medium.MediumKurzzeichen, text: medium.MediumKurzzeichen}] : [],    
      // NormaldruckOPS: req ? [{key: medium.Normaldruck.toString(), text: medium.Normaldruck.toString()}] : [], 
      NormaldruckOPS: this.props.currentRecord ? [{key: medium.Normaldruck.toString(), text: medium.Normaldruck.toString()}] : [], 
    
      // ZykluszeitenZyklusdauerIsMultiline: req ? req[fn.constRMLZykluszeitenZyklusdauerIN]?.length > constZyklusMaxWidthChar : false,
      ZykluszeitenZyklusdauerIsMultiline: this.props.currentRecord ? 
        this.props.currentRecord.ZykluszeitenZyklusdauer?.length > constZyklusMaxWidthChar : false,
      
      currentRecord: this.props.currentRecord ? this.props.currentRecord : 
        Object.assign(new RohrgefuehrteMedienRecord, {AntragstellerIsAnschlussnehmer: true}),
  
      currentRecordErrors: new RohrgefuehrteMedienErrors
        
    } as IRohrgefuehrteMedienRequestState;
  }

  public async componentDidMount() {
    console.log('Rohrgeführte Medien componentDidMount fired');

  }

  onChangeChoiceGroup = async (ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined, option?: IChoiceGroupOption | undefined) => {
    const state:IRohrgefuehrteMedienRequestState = { ...this.state };

    if (option?.key) {
      state.currentRecord.AntragsVariante = option.key;
      
      // clear variant fields, which are not the same for all variants
      state.currentRecord.KuenftigeMengeMin = "";             // * Erstanforderung, Änderung
      state.currentRecord.KuenftigeMengeStundenmittel = "";       // * Erstanforderung, Änderung
      state.currentRecord.KuenftigeMengeMax = "";             // * Erstanforderung, Änderung
      state.currentRecord.BisherigeMengeStundenmittel = "";      // * Änderung, Abmeldung
      state.currentRecord.ANMStellenBezeichnung = "";     // * Änderung, Abmeldung
      state.currentRecord.BisherigerAnschlussNWDN = "";          //   Änderung, Abmeldung
      state.currentRecord.SonderfallsBeschreibung = "";              // * Sonderfall

      state.currentRecordErrors.AntragsVariante = "";
      
      // clear error messages for variant fields, which are not the same for all variants
      state.currentRecordErrors.KuenftigeMengeMin = "";             // * Erstanforderung, Änderung
      state.currentRecordErrors.KuenftigeMengeStundenmittel = "";       // * Erstanforderung, Änderung
      state.currentRecordErrors.KuenftigeMengeMax = "";             // * Erstanforderung, Änderung
      state.currentRecordErrors.BisherigeMengeStundenmittel = "";      // * Änderung, Abmeldung
      state.currentRecordErrors.ANMStellenBezeichnung = "";     // * Änderung, Abmeldung
      state.currentRecordErrors.BisherigerAnschlussNWDN = "";          //   Änderung, Abmeldung
      state.currentRecordErrors.SonderfallsBeschreibung = "";              // * Sonderfall
    }
    else {
      console.log("onChangeChoiceGroup: missing option.key");
    }

    this.setState(state);
  };

  onChangeMedium = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined) => {
    
    const state: IRohrgefuehrteMedienRequestState = { ...this.state };
    state.currentRecord.Medium = option.text;

    const MedienFiltered = this.props.medien.filter(m => m.Medium == option.text);

    state.MediumKurzzeichenOPS = MedienFiltered.map(m => ({ key: m.MediumKurzzeichen, text: m.MediumKurzzeichen }) );

    if (state.MediumKurzzeichenOPS.length == 1) {
      state.currentRecord.MediumKurzzeichen = state.MediumKurzzeichenOPS[0].text;
    }

    state.NormaldruckOPS = MedienFiltered.map(m => ({ key: m.Normaldruck.toString(), text: m.Normaldruck.toString() }) );

    if (state.NormaldruckOPS.length == 1) {
      state.currentRecord.Normaldruck = state.NormaldruckOPS[0].text;
    }

    const unitOPS = MedienFiltered.map(m => ({ key: m.unit, text: m.unit }) );

    if (unitOPS.length == 1) {
      state.currentRecord.unit = unitOPS[0].text;
    }

    this.setState(state);
  };

  onChangeBetriebsweise = async (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption<any> | undefined, index?: number | undefined) => {
    const state: IRohrgefuehrteMedienRequestState = { ...this.state };

    // debugger;
    state.currentRecord.Betriebsweise = option?.text;
    if (option?.text == "diskontinuierlich") {
    } else {
      //clear field
      state.currentRecord.ZykluszeitenZyklusdauer = "";      
      //clear field level error
      state.currentRecordErrors.ZykluszeitenZyklusdauer = "";
    }

    // await this.setState(state);
    this.setState(state);
  };

  onChangeZykluszeitenZyklusdauer = async (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) => {
    // debugger;
    // this.setState({
    //   ZykluszeitenZyklusdauerIsMultiline : event.currentTarget.value.length > constZyklusMaxWidthChar,
    //   currentRecord: {... this.state.currentRecord, ZykluszeitenZyklusdauer: event.currentTarget.value}
    // });
    // debugger;

    const state: IRohrgefuehrteMedienRequestState = { ...this.state };

    state.ZykluszeitenZyklusdauerIsMultiline = event.currentTarget.value.length > constZyklusMaxWidthChar;
    state.currentRecord.ZykluszeitenZyklusdauer = event.currentTarget.value;
    state.currentRecordErrors.ZykluszeitenZyklusdauer = "";

    this.setState(state);
  };


  render() {
    return (
      <React.Fragment>
        {BaseDataFragment.bind(this)()}

        <hr />
		
        <Row>
          <Col md="12" style={{ textAlign: "left" }}>
            <h5 style={{ alignContent: "left", alignItems: "left" }}>
              Medium
            </h5>
          </Col>
        </Row>
        <Row>
          <Col md="4">
            <Dropdown
              id="Medium"
              label={this.props.formFields.find(f => f.Id === "Medium").Label}
              // label="Medium"
              placeholder={constGenericDropdownPlaceholder}
              options={this.state.MediumOPS}
              selectedKey={this.state.currentRecord.Medium}
              styles={dropdownStyles}
              disabled={this.state.formReadOnly}
              onChange={this.onChangeMedium}
              required
              errorMessage={this.state.currentRecordErrors.Medium}
              onBlur={commonCode.ValidateOnBlur.bind(this)}
            />
          </Col>
          <Col md="2">
            <Dropdown
              id="MediumKurzzeichen"
              label={this.props.formFields.find(f => f.Id === "MediumKurzzeichen").Label}
              // label="Medium (Kurzzeichen)"
              placeholder={constGenericDropdownPlaceholder}
              selectedKey={this.state.currentRecord.MediumKurzzeichen}
              options={this.state.MediumKurzzeichenOPS}
              styles={dropdownStyles}
              disabled={this.state.formReadOnly}
              onChange={commonCode.onChangeDropdown.bind(this)}
            />
          </Col>
          <Col md="2">
            <Dropdown
              id="Normaldruck"
              label={this.props.formFields.find(f => f.Id === "Normaldruck").Label}
              // label="Betriebsdruck (barü)"
              placeholder={constGenericDropdownPlaceholder}
              selectedKey={this.state.currentRecord.Normaldruck}
              options={this.state.NormaldruckOPS}
              styles={dropdownStyles}
              disabled={this.state.formReadOnly}
              onChange={commonCode.onChangeDropdown.bind(this)}
            />
          </Col>
          <Col md="4">
            <div ref={this.buttonContainerRef}>
              <TextField
                id="BedarfsterminGeschaetzt"
                label={this.props.formFields.find(f => f.Id === "BedarfsterminGeschaetzt").Label}
                autoComplete={this.props.autoCompleteMode}
                value={this.state.currentRecord.BedarfsterminGeschaetzt}
                styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                disabled={this.state.formReadOnly}
                onClick={commonCode.toggleShowCalendar.bind(this)}
                required
                errorMessage={this.state.currentRecordErrors.BedarfsterminGeschaetzt}
                onBlur={commonCode.ValidateOnBlur.bind(this)}
              />
            </div>
            {this.state.showCalendar && (
              <Callout
                isBeakVisible={false}
                gapSpace={0}
                doNotLayer={false}
                target={this.buttonContainerRef}
                directionalHint={DirectionalHint.bottomLeftEdge}
                onDismiss={commonCode.hideCalendar.bind(this)}
                // goToToday={false}
                setInitialFocus
              >
                <FocusTrapZone isClickableOutsideFocusTrap>
                  <Calendar
                    onSelectDate={(date: Date, selectedDateRangeArray?: Date[] | undefined) => { 
                      commonCode.onSelectMonthCalendarNested.bind(this)(date, "BedarfsterminGeschaetzt");
                    }}
                    onDismiss={commonCode.hideCalendar.bind(this)}
                    isMonthPickerVisible
                    highlightCurrentMonth
                    isDayPickerVisible={false}
                    strings={DateStrings}
                    minDate={this.state.minDate}
                  />
                </FocusTrapZone>
              </Callout>
            )}
          </Col>
        </Row>
        <hr />
        {/*Radio button ********************** */}
        <Row>
          <Col md="8" style={{ textAlign: "left" }}>
            <ChoiceGroup
              id="AntragsVariante"
              className="inlineflex"
              options={this.VariantenOPS}
              selectedKey={this.state.currentRecord.AntragsVariante}
              required
              disabled={this.state.formReadOnly}
              onChange={this.onChangeChoiceGroup}
            />
          </Col>
          <Col md="4" style={{ textAlign: "left" }}>
            {this.state.currentRecordErrors.AntragsVariante.length > 0 ? (
              <MessageBar
                messageBarType={MessageBarType.error}
                isMultiline={false}
              >
                {this.state.currentRecordErrors.AntragsVariante}
              </MessageBar>
            ) : null}
          </Col>
        </Row>
        <hr />

        {this.state.currentRecord.AntragsVariante !== "" ? 
          <>
            <Row>
              <Col md="12" style={{ textAlign: "left" }}>
                <h5>{VariantenRM.filter(el => el.Key === this.state.currentRecord.AntragsVariante)[0]?.AbschnittTitel}</h5>
              </Col>
            </Row>                  
            {this.state.currentRecord.AntragsVariante === constVarianteKeyAbmeldung ||
             this.state.currentRecord.AntragsVariante === constVarianteKeyAenderung ? (
          <Row>
            <Col md="6">
              <TextField
                id="ANMStellenBezeichnung"
                label={this.props.formFields.find(f => f.Id === "ANMStellenBezeichnung").Label}
                // label="Abnahmestelle / Messstellen-Bezeichnung"
                maxLength={125}
                autoComplete={this.props.autoCompleteMode}
                placeholder="Max. 125"
                required
                disabled={this.state.formReadOnly}
                value={this.state.currentRecord.ANMStellenBezeichnung}
                styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                onChange={commonCode.onChangeTextBoxBasic.bind(this)}
                errorMessage={this.state.currentRecordErrors.ANMStellenBezeichnung}
                onBlur={commonCode.ValidateOnBlur.bind(this)}
              />
            </Col>
            <Col md="3">
              <TextField
                id="BisherigeMengeStundenmittel"
                label={this.props.formFields.find(f => f.Id === "BisherigeMengeStundenmittel").Label}
                // label="Bisherige Abnahmemenge (Stundenmittel)"
                suffix={this.state.currentRecord.unit}
                autoComplete={this.props.autoCompleteMode}
                maxLength={12}
                required
                disabled={this.state.formReadOnly}
                value={this.state.currentRecord.BisherigeMengeStundenmittel}
                styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                onChange={commonCode.onChangeTextBox_NumberFld.bind(this)}
                errorMessage={this.state.currentRecordErrors.BisherigeMengeStundenmittel}
                onBlur={commonCode.ValidateOnBlur.bind(this)}
              />
            </Col>
            <Col md="3">
              <TextField
                id="BisherigerAnschlussNWDN"
                label={this.props.formFields.find(f => f.Id === "BisherigerAnschlussNWDN").Label}
                // label="Bisheriger Anschluss (Nennweite DN)"
                autoComplete={this.props.autoCompleteMode}
                suffix="mm"
                maxLength={50}
                disabled={this.state.formReadOnly}
                value={ this.state.currentRecord.BisherigerAnschlussNWDN }
                styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                onChange={commonCode.onChangeTextBox_NumberFld.bind(this)}
              />
            </Col>
          </Row>
            ) : null}
            {/* ********************** */}
            {this.state.currentRecord.AntragsVariante === constVarianteKeyErstanforderung ||
             this.state.currentRecord.AntragsVariante === constVarianteKeyAenderung ? (
          <Row>
            <Col md="4">
              <TextField
                id="KuenftigeMengeStundenmittel"
                label={this.props.formFields.find(f => f.Id === "KuenftigeMengeStundenmittel").Label}
                // label="künftige Abnahmemenge (Stundenmittel)"
                autoComplete={this.props.autoCompleteMode}
                suffix={this.state.currentRecord.unit}
                maxLength={12}
                required
                disabled={this.state.formReadOnly}
                value={this.state.currentRecord.KuenftigeMengeStundenmittel}
                styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                onChange={commonCode.onChangeTextBox_NumberFld.bind(this)}
                errorMessage={this.state.currentRecordErrors.KuenftigeMengeStundenmittel}
                onBlur={commonCode.ValidateOnBlur.bind(this)}
              />
            </Col>
            <Col md="4">
              <TextField
                id="KuenftigeMengeMin"
                label={this.props.formFields.find(f => f.Id === "KuenftigeMengeMin").Label}
                // label="künftige Abnahmemenge (Min-Wert)"
                suffix={this.state.currentRecord.unit}
                autoComplete={this.props.autoCompleteMode}
                disabled={this.state.formReadOnly}
                value={this.state.currentRecord.KuenftigeMengeMin}
                styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                maxLength={12}
                onChange={commonCode.onChangeTextBox_NumberFld.bind(this)}
                required
                errorMessage={this.state.currentRecordErrors.KuenftigeMengeMin}
                onBlur={commonCode.ValidateOnBlur.bind(this)}
              />
            </Col>
            <Col md="4">
              <TextField
                id="KuenftigeMengeMax"
                label={this.props.formFields.find(f => f.Id === "KuenftigeMengeMax").Label}
                // label="künftige Abnahmemenge (Max-Wert)"
                suffix={this.state.currentRecord.unit}
                autoComplete={this.props.autoCompleteMode}
                maxLength={12}
                disabled={this.state.formReadOnly}
                value={this.state.currentRecord.KuenftigeMengeMax}
                styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                onChange={commonCode.onChangeTextBox_NumberFld.bind(this)}
                required
                errorMessage={this.state.currentRecordErrors.KuenftigeMengeMax}
                onBlur={commonCode.ValidateOnBlur.bind(this)}
              />
            </Col>
          </Row>
            ) : null}
            {/* ********************** */}
            {this.state.currentRecord.AntragsVariante === constVarianteKeySonderfall ? (
          <Row>
            <Col md="12">
              <TextField
                id="SonderfallsBeschreibung"
                label={this.props.formFields.find(f => f.Id === "SonderfallsBeschreibung").Label}
                // label="Beschreibung des Sonderfalls"
                value={this.state.currentRecord.SonderfallsBeschreibung}
                styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                multiline
                autoAdjustHeight
                maxLength={5000}
                placeholder="Max. 5000"
                autoComplete={this.props.autoCompleteMode}
                required
                disabled={this.state.formReadOnly}
                onChange={commonCode.onChangeTextBoxBasic.bind(this)}
                errorMessage={this.state.currentRecordErrors.SonderfallsBeschreibung}
                onBlur={commonCode.ValidateOnBlur.bind(this)}
              />
            </Col>
          </Row>
            ) : null}
            {/* ********************** */}
          </>
        : null}

        <Row>
          <Col md="12">
            <TextField
              id="BemerkungAntragsteller"
              label={this.props.formFields.find(f => f.Id === "BemerkungAntragsteller").Label}
              // label="Verwendungszweck (Kurzbeschreibung)"
              value={this.state.currentRecord.BemerkungAntragsteller}
              styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
              multiline
              autoAdjustHeight
              maxLength={2048}
              placeholder=" Max. 2048"
              autoComplete={this.props.autoCompleteMode}
              disabled={this.state.formReadOnly}
              onChange={commonCode.onChangeTextBoxBasic.bind(this)}                   
            />
          </Col>
        </Row>
        <Row>
          <Col md="3">
            <Dropdown
              id="Betriebsweise"
              label={this.props.formFields.find(f => f.Id === "Betriebsweise").Label}
              // label="Betriebsweise"
              placeholder={constGenericDropdownPlaceholder}
              options={BetriebsweiseOPSConsts}
              selectedKey={this.state.currentRecord.Betriebsweise}
              styles={dropdownStyles}
              required
              disabled={this.state.formReadOnly}
              onChange={this.onChangeBetriebsweise}
              errorMessage={this.state.currentRecordErrors.Betriebsweise}
              onBlur={commonCode.ValidateOnBlur.bind(this)}
            />
          </Col>
          {/* {this.state.ZykluszeitenZyklusdauerUsed === true ? ( */}
          {this.state.currentRecord.Betriebsweise === "diskontinuierlich" ? (
            <Col md="6">
              <TextField
                id="ZykluszeitenZyklusdauer"
                label={this.props.formFields.find(f => f.Id === "ZykluszeitenZyklusdauer").Label}
                // label="Zykluszeiten / Zyklusdauer"
                value={this.state.currentRecord.ZykluszeitenZyklusdauer}
                styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                autoComplete={this.props.autoCompleteMode}
                // multiline={this.state.ZykluszeitenZyklusdauerIsMultiline}
                multiline={this.state.currentRecord?.ZykluszeitenZyklusdauer?.length > constZyklusMaxWidthChar}
                // autoAdjustHeight={this.state.ZykluszeitenZyklusdauerIsMultiline}
                autoAdjustHeight={this.state.currentRecord?.ZykluszeitenZyklusdauer?.length > constZyklusMaxWidthChar}
                maxLength={500}
                placeholder="Max. 500"
                // required={this.state.ZykluszeitenZyklusdauerRequired}
                required
                disabled={this.state.formReadOnly}
                onChange={this.onChangeZykluszeitenZyklusdauer}
                errorMessage={this.state.currentRecordErrors.ZykluszeitenZyklusdauer}
                onBlur={commonCode.ValidateOnBlur.bind(this)}
              />
            </Col>
          ) : null}
          {this.state.companyIsISG === true ? (
            <Col md="3">
              <TextField
                id="KontoEnergieverrechnung"
                label={this.props.formFields.find(f => f.Id === "KontoEnergieverrechnung").Label}
                // label="Konto für Energieverrechnung"
                value={this.state.currentRecord.KontoEnergieverrechnung}
                styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                maxLength={10}
                placeholder="Max. 10"
                autoComplete={this.props.autoCompleteMode}
                disabled={this.state.formReadOnly}
                // required={this.state.KontoEnergieverrechnungRequired}
                required
                onChange={commonCode.onChangeTextBoxBasic.bind(this)}
                errorMessage={this.state.currentRecordErrors.KontoEnergieverrechnung}
                onBlur={commonCode.ValidateOnBlur.bind(this)}
              />
            </Col>
          ) : null}
        </Row>
        <hr />

        <Stack
          horizontal
          horizontalAlign="space-between"
        >
          <Stack.Item align="stretch">
            {`Antragsdatum: ${this.state.currentRecord.Antragsdatum.toLocaleString("de-de", { year: 'numeric', month: 'long', day: 'numeric' })}`}
          </Stack.Item>

          {!this.state.formReadOnly ? 
            <Stack.Item align="stretch">                    
              <Stack
                verticalAlign="center"
                verticalFill
              >   
                <Stack.Item
                  hidden={!this.state.showSpinner}
                  align="end"
                  style={{width: 120}}
                >  
                  <Spinner
                    size={SpinnerSize.medium}
                    label="Bitte warten..."
                  />
                </Stack.Item>
                <Stack.Item
                  hidden={this.state.showSpinner}
                  align="end"
                  style={{width: 120}}
                > 
                  <PrimaryButton
                    text="Abschließen"
                    disabled={this.state.formReadOnly}
                    // onClick={async () => { await commonCode.onSubmitNested.bind(this)(apiEndpointSubmit, FormFieldsRM, false); } }
                    onClick={async () => { await commonCode.onSubmitNested.bind(this)(apiEndpointSubmit, this.props.noFormDisable); } }
                  />
                </Stack.Item>
                <Stack.Item
                  hidden={this.state.showSpinner}
                  align="center"
                > 
                  {this.state.submitMessage}
                </Stack.Item>
              </Stack>
            </Stack.Item>
          : 
            <Stack.Item align="stretch">
              {this.state.submitMessage}
            </Stack.Item>                    
          }
        </Stack>
      </React.Fragment>
    );
  }
}

export default RohrgefuehrteMedienRequest;
